import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, ButtonGroup, Table } from "reactstrap";

import { IoAdd } from "react-icons/io5";
import swal from "sweetalert";
import { LoadingSpinner, isUrdu } from "../../../../constants/const.js";
import { GetLanguageString, NoResult } from "../../../helper/Components.js";
import { GetCustomStyles, GetSelectedLanguage } from "../../../helper/Method.js";
import { ApiFinance } from "../ApiFinance.js";
import AddFinanceAccountCategoryTypes from "./AddFinanceAccountCategoryTypes.js";
import EditFinanceAccountCategoryTypes from "./EditFinanceAccountCategoryTypes.js";

const FinanceAccountCategoryTypes = ({ activeTab }) => {
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const [financeAccountCategoryTypes, setFinanceAccountCategoryTypes] = useState([]);
  const [editModal, setEditModal] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [reload, setReload] = useState(false);
  const [editValues, setEditValues] = useState();

  useEffect(() => {
    if (activeTab === "financeAccountCategoryTypes") {
      setLoading(true);
      ApiFinance()
        .GetFinanceAccountCategoryTypes()
        .then((res) => {
          setFinanceAccountCategoryTypes(res.data);
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
        });
    }
  }, [activeTab, reload]);

  const handleOnDelete = (value) => {
    swal({
      title: t("common_delete_message"),
      text: t("common_delete_detail_message"),
      icon: "warning",
      buttons: true,
      className: GetSelectedLanguage() === "en" ? "" : "ur",
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        setLoading(true);
        ApiFinance()
          .DeleteFinanceAccountCategoryType(value)
          .then((res) => {
            // swal({
            //   title: t("finance_finance_account_category_type_deleted"),
            //   className: GetSelectedLanguage() === "en" ? "" : "ur",
            //   icon: "success",
            //   buttons: "OK",
            // });
            setReload(!reload);
            setLoading(false);
          })
          .catch((err) => {
            console.log(err);
            swal({
              title: err,
              icon: "error",
              buttons: "OK",
            });
            setLoading(false);
          });
      }
    });
  };

  const handleOnEdit = (e) => {
    setEditValues(e);
    setEditModal(true);
  };

  return (
    <div>
      {editModal ? (
        <EditFinanceAccountCategoryTypes
          accountCategoryTypeValues={editValues}
          setEditModal={setEditModal}
          setReload={setReload}
          reload={reload}
        />
      ) : null}
      {addModal ? (
        <AddFinanceAccountCategoryTypes
          setAddModal={setAddModal}
          setReload={setReload}
          reload={reload}
        />
      ) : null}
      <div className="ibox ">
        <div className="ibox-title">
          <h5>
            <GetLanguageString props="finance_tab_finance_account_category_types" />
          </h5>
          <Button
            color="white"
            size="sm"
            className={GetCustomStyles().btn_style}
            onClick={() => {
              setAddModal(true);
            }}
          >
            <IoAdd
              size={18}
              color="#18A689"
              style={{ marginRight: 3, marginBottom: 1 }}
            />
            {<GetLanguageString props="finance_tab_finance_account_category_types_add" />}
          </Button>
        </div>
        <div className="ibox-content">
          {!loading ? (
            financeAccountCategoryTypes.length !== 0 ? (
              <div className="table-responsive">
                <Table responsive>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>{<GetLanguageString props="common_type" />}</th>
                      <th>
                        {<GetLanguageString props="settings_code" />}
                      </th>
                      <th className="text-right">
                        {<GetLanguageString props="common_action" />}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {financeAccountCategoryTypes.map((record, index) => {
                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td className={isUrdu(record.type) ? "ur" : ""}>
                            {record.type}
                          </td>
                          <td
                            className={isUrdu(record.code) ? "ur" : ""}
                          >
                            {record.code}
                          </td>
                          <td className="text-right">
                            <ButtonGroup>
                              <Button
                                color="white"
                                size="sm"
                                onClick={() => handleOnEdit(record)}
                              >
                                {<GetLanguageString props="common_edit" />}
                              </Button>
                              <Button
                                color="white"
                                size="sm"
                                onClick={() => handleOnDelete(record.id)}
                              >
                                {<GetLanguageString props="common_delete" />}
                              </Button>
                            </ButtonGroup>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            ) : (
              <NoResult />
            )
          ) : (
            LoadingSpinner()
          )}
        </div>
      </div>
    </div>
  );
};

export default FinanceAccountCategoryTypes;
